import React from 'react';
import './Product.css';

function Product() {
  return (
    <div className="product-page">
      <section className="product-hero">
        <div className="product-hero-content">
          <h1>Zibit Product Features</h1>
          <p>Everything you need to plan successful trade shows</p>
        </div>
      </section>

      <section className="product-features">
        <div className="feature-section">
          <h2>Playbook Builder</h2>
          <p>Create customized trade show strategies based on your goals and budget.</p>
        </div>

        <div className="feature-section">
          <h2>Task Management</h2>
          <p>Track every detail from booth setup to post-show follow-up.</p>
        </div>

        <div className="feature-section">
          <h2>Budget & ROI Calculator</h2>
          <p>Monitor expenses and measure success with cost-per-lead metrics.</p>
        </div>

        <div className="feature-section">
          <h2>AI-Enhanced Strategy</h2>
          <p>Get intelligent recommendations to optimize your trade show presence.</p>
        </div>
      </section>
    </div>
  );
}

export default Product;